import { render, staticRenderFns } from "./splitInvoice.vue?vue&type=template&id=bbf1b918"
import script from "./splitInvoice.vue?vue&type=script&lang=js"
export * from "./splitInvoice.vue?vue&type=script&lang=js"
import style0 from "./splitInvoice.vue?vue&type=style&index=0&id=bbf1b918&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports